const userManagementAr = {
    wareHouse: require('../../lang/ar/user_management/BusinessAreaWareHouse').default,
    city: require('../../lang/ar/user_management/City').default,
    company: require('../../lang/ar/user_management/Company').default,
    businessArea: require('../../lang/ar/user_management/CompanyBusinessArea').default,
    costCenter: require('../../lang/ar/user_management/CostCenter').default,
    country: require('../../lang/ar/user_management/Country').default,
    currency: require('../../lang/ar/user_management/Currency').default,
    mainMenu: require('../../lang/ar/user_management/MainMenu').default,
    permissionMenu: require('../../lang/ar/user_management/PermissionMenu').default,
    role: require('../../lang/ar/user_management/Role').default,
    rolePermission: require('../../lang/ar/user_management/RolePermission').default,
    state: require('../../lang/ar/user_management/State').default,
    subMenu: require('../../lang/ar/user_management/SubMenu').default,
    tax: require('../../lang/ar/user_management/Tax').default,
    taxType: require('../../lang/ar/user_management/TaxType').default,
    userRole: require('../../lang/ar/user_management/UserRole').default,
};

export default userManagementAr;